<template>
  <div class="from-item">
    <div class="from-item-num">{{ num }}</div>
    <div class="from-item-name">{{ name }}</div>
    <div class="from-item-main">
      <slot />
    </div>
  </div>
</template>
<script>
export default {
  name: 'FromItem',
  props: {
    num: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  created() {},
  mounted() {},
  methods: {}
}
</script>
<style lang="less" scoped>
.from-item{
  position: relative;
  background: #fff;
  margin-bottom: 10px;
  overflow: hidden;
  &-num{
    position: absolute;
    top: 0;
    left: 0;
    background: #217FFF;
    height: 40px;
    width: 40px;
    z-index: 1;
    border-radius: 0 0 78% 0;
    color: #fff;
    line-height: 36px;
    text-align: center;
  }
  &-name {
    margin-left: 48px;
    font-size: 16px;
    line-height: 2;
    color: #333;
    min-height: 40px;
  }
  &-main {
    margin: 10px;
  }
}
</style>
